import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProjectDetail = () => {
  const { id } = useParams();
  const project = useSelector((state) => 
    state.projects.find(p => p.id === parseInt(id))
  );

  if (!project) {
    return (
      <div className="page-container">
        <h2>Project not found</h2>
        <Link to="/projects">Back to Projects</Link>
      </div>
    );
  }

  return (
    <div className="page-container project-detail">
      <h1>{project.title}</h1>
      <p className="description">{project.description}</p>
      
      <div className="detail-section">
        <h3>Tech Stack</h3>
        <ul className="tech-list">
          {project.tech.map((t, i) => <li key={i}>{t}</li>)}
        </ul>
      </div>

      <Link to="/projects" className="back-link">← Back to Projects</Link>
    </div>
  );
};

export default ProjectDetail;